import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { MysqlRanks } from '../../../graphqlTypes'

const Container = styled.li`
  margin: 0 auto;
  padding: 0;
  width: 100%;
`

const ProductHeading = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 5px;
`

const EmblemContainer = styled.figure`
  width: 96px;
  height: 96px;
  min-width: 96px;
`

const EmblemImage = styled.img`
  width: 100%;
  height: 100%;
`

const ImageFrame = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 230px;
  height: 230px;
  margin: 0 auto;
  text-decoration: none;
`

const Image = styled.img`
  object-fit: contain;
  max-width: 230px;
  max-height: 230px;
`

const TextInfo = styled.div`
  color: ${({ theme }) => theme.palette.font.main};
  font-weight: bold;
  margin: 0 0 0 16px;
`

const Manufacturer = styled.p`
  font-size: 14px;
  line-height: 1;
  margin: 0 0 8px;
`

const ProductName = styled.p`
  font-size: 18px;
  line-height: 22px;
`

type Props = {
  rank: MysqlRanks
}

export default function GrandAwardItem({ rank }: Props) {
  const product = rank.products!

  return (
    <Container>
      <ProductHeading>
        <EmblemContainer>
          <EmblemImage
            alt={'ママリ口コミ大賞 大賞エンブレム画像'}
            src={`${product.fields!.grandAwardImageUrl}?auto=format&w=192&h=192`}
            decoding={'async'}
          />
        </EmblemContainer>
        <TextInfo>
          {product.manufacturer && <Manufacturer>{product.manufacturer}</Manufacturer>}
          <ProductName>{product.name}</ProductName>
        </TextInfo>
      </ProductHeading>
      <ImageFrame to={product.fields!.pagePath!}>
        <LazyLoadComponent>
          <Image
            alt={product.name!}
            src={`${product.fields!.imageUrl}?auto=format&fit=clip&w=460&h=460`}
            decoding={'async'}
          />
        </LazyLoadComponent>
      </ImageFrame>
    </Container>
  )
}
